<template>
  <com-page>
    <com-search :columns="searchColumn" @search="handleSearch">
      <template>
        <el-button type="primary" @click="handleAddPartner">添加</el-button>
      </template>
    </com-search>
    <com-card>
      <com-table
        :columns="columns"
        :api="api"
        ref="tableRef"
      >
        <template #status="row">
          <el-switch
            v-model="row.data.status"
            :active-value="1"
            :inactive-value="0"
            @change="handleStatus(row.data)"
          >
          </el-switch>
        </template>
        <template #type="row">
          {{ typeTag[row.data.type] }}
        </template>
        <template #createTime="row">
          {{ row.data.createTime | formatDate }}
        </template>
        <template #operation="row">
          <el-button type="primary" @click="handleCheck(row.data)" size="mini">查看</el-button>
          <el-button type="primary" @click="handleEdit(row.data)" size="mini">编辑</el-button>
          <el-button type="danger " @click="handleDel(row.data)" class="mb-5rpx" size="mini"
            >删除</el-button
          >
        </template>
      </com-table>
    </com-card>
    <the-add-partners ref="partnerRef" @success="update"></the-add-partners>
  </com-page>
</template>

<script>
import { partnersListApi, delPartnerApi, parentsStatusApi, partnersLevelApi } from '@/api/partners'
import theAddPartners from './components/the-add-partners'

export default {
  components: { theAddPartners },
  data() {
    return {
      api: partnersListApi,
      searchColumn: [
        {
          label: '合伙人名称',
          prop: 'name',
          type: 'input'
        },
        {
          label: '手机号',
          prop: 'phone',
          type: 'input'
        },
        {
          label: '身份类别',
          prop: 'type',
          type: 'select',
          option: [
            {
              label: '合伙人',
              value: 1
            },
            {
              label: '商家',
              value: 2
            },
            {
              label: '代理商',
              value: 3
            }
          ]
        },
        {
          label: '注册时间',
          type: 'date',
          prop: 'date'
        }
      ],
      exportQuery: {
        pageIndex: 1,
        pageSize: 10000
      },
      columns: [
        {
          label: '编号',
          prop: 'number',
          minWidth: '180'
        },
        {
          label: '身份类别',
          prop: 'type',
          type: 'slot',
          slotName: 'type',
          minWidth: '180'
        },
        {
          label: '姓名',
          prop: 'name',
          minWidth: '180'
        },
        {
          label: '手机号',
          prop: 'phone',
          minWidth: '150'
        },
        {
          label: '证件号',
          prop: 'idCard',
          auto: true
        },
        {
          label: '等级',
          prop: 'levelName',
          minWidth: '150'
        },
        {
          label: '投资金额',
          prop: 'invest',
          auto: true,
          minWidth: '170'
        },
        {
          label: '注册日期',
          prop: 'createTime',
          type: 'slot',
          slotName: 'createTime',
          minWidth: '180'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          minWidth: '180',
          slotName: 'operation',
          fixed: 'right'
        }
      ],
      typeTag: {
        1: '合伙人',
        2: '商家',
        3: '代理商',
      }
    }
  },
  created() {
    this.getLevel()
  },
  methods: {
    getLevel() {
      partnersLevelApi('PARTNER_LEVEL').then((res) => {
        const { value } = res.data.setting
        const partnerList = JSON.parse(value)
        this.searchColumn.map((item) => {
          if (item.prop === 'level') {
            item.option = partnerList.map((child) => {
              child.value = child.code
              child.label = child.name
              return child
            })
          }
          return item
        })
      })
    },
    handleSearch(e) {
      if (e.area && e.area.length) {
        e.area = e.area.at(-1)
      }
      const params = {
        ...e,
        startTime: e.beginTime
      }

      this.$refs.tableRef.search(params)
    },
    update() {
      this.$refs.tableRef.getList()
    },
    handleAddPartner() {
      const param = {
        type: 'created'
      }
      this.$refs.partnerRef.open(param)
    },
    handleCheck(row) {
      this.$router.push({ path: 'partners-detail', query: {code: row.code} })
    },
    handleDel(row) {
      this.$confirm('此操作将永久删除该合伙人, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const param = {
            code: row.code
          }
          delPartnerApi(param).then(() => {
            this.$refs.tableRef.getList()
          })
        })
        .catch(() => {})
    },
    handleStatus(val) {
      const param = {
        status: val.status,
        code: val.code
      }
      parentsStatusApi(param).then(() => {
        this.update()
      })
    },
    handleEdit(row) {
      const param = {
        type: 'edit',
        row
      }
      this.$refs.partnerRef.open(param)
    },
  },
}
</script>
